import { React, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';

import * as ReactGA from "react-ga";
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getHreflangLinks } from '../../shared/utility';

const Head = props => {
    // const imageName = 'metatags:' + props.id + '.image';
    const imageName = props.id + '.image';
    const langFolder = props.i18n.language === "pt" ? "pt" : "en";
    const img = props.i18n.exists('metatags:' + props.id + '.image', langFolder) ? require("../../assets/images/shared/" + langFolder + props.i18n.getResource(langFolder, 'metatags', imageName)) : null;
    const title = 'metatags:' + props.id + '.title';
    const description = 'metatags:' + props.id + '.description';
    const linkServer = 'http://sysmatch.com';
    const currentLink = navigator.userAgent !== 'ReactSnap' ? window.location.href : (linkServer + window.location.pathname);
    const canonicalLink = 'https://www.sysmatch.com' + window.location.pathname;
    const hreflangLinks = getHreflangLinks(props.i18n, window.location.pathname, 'https://www.sysmatch.com');
    const defaultLink = hreflangLinks.find(link => link.hrefLang === 'en');

    //Structured Data
    const [displayStructuredData, setDisplayStructuredData] = useState(null);
    useEffect(() => {
        setDisplayStructuredData(props.structuredData)
    }, [props.structuredData]);

    const location = useLocation();

    //set pageview on page change
    {/* Uncomment for prod version*/ }
    useEffect(() => {
        if (props.acceptedCookie) {
            ReactGA.pageview(location.pathname + location.search);
        }
    }, [location])

    {/* Uncomment for prod version*/ }
    useEffect(() => {
        //set GTM
        if (props.acceptedCookie) {
            const tagManagerArgs = {
                gtmId: 'GTM-WVPF3Q4'
            }
            TagManager.initialize(tagManagerArgs);
        }
    }, [props.acceptedCookie])


    let imgLink = null;
    if (img)
        imgLink = navigator.userAgent !== 'ReactSnap' ? window.location.origin + img : linkServer + img;
    return (
        <Helmet defaultTitle="Sysmatch">
            <html lang={props.i18n.language} />
            <title>{props.t(title) + " | Sysmatch"}</title>
            <meta name="title" property="og:title" content={props.t(title) + " | Sysmatch"} />
            {props.id !== "cookies" && props.id !== "privacy" && props.id !== "personal-data" && (<meta name="description" content={props.t(description)} />)}
            {props.id !== "cookies" && props.id !== "privacy" && props.id !== "personal-data" && (<meta name="og:description" content={props.t(description)} />)}
            <link rel="canonical" href={canonicalLink} />
            {hreflangLinks.map(link => <link key={link.hrefLang} rel="alternate" hrefLang={link.hrefLang} href={link.href} />)}
            {defaultLink && <link rel="alternate" hrefLang="x-default" href={defaultLink.href} />}
            <meta property="og:url" content={currentLink} />
            <meta property="og:type" content="WebPage" />
            <meta property="og:site_name" content="Sysmatch" />
            {img ? (<meta name="image" property="og:image" content={imgLink} />) : null}
            {/* HELMET DOCS https://www.npmjs.com/package/react-helmet#reference-guide */}
            <meta name="google-site-verification" content="sRQCa3X6Eeih8fAnOTu5xl_JJOHLkMfqCmNuw_4xEsg" />
            {/* Uncomment for prod version*/}
            {displayStructuredData && <script type="application/ld+json">{displayStructuredData}</script>}

        </Helmet>

    );
}

const mapStateProps = state => {
    return {
        acceptedCookie: state.cookies.accepted,
        structuredData: state.jobs.jobStructuredData,
    }
}

export default connect(mapStateProps)(withTranslation('metatags')(Head));